export interface IGetOrgInfoReq {
    identitiesOrOrgNames: string[],
    queryType: QueryTypeEnums
}

export enum QueryTypeEnums {
    Identities,
    OrgNames,
}

export interface IGetROUResponse {
    organizations: Organization[]
}

export interface Organization {
    orgName: string;
    parentOrgName: string;
    parentOrgId: string;
    managerID: string;
    division: string;
    managerFullName: string;
}

export interface ICoordinator {
    divisionTitle?: string | null;
    idmRole?: string | null;
    loginName?: string | null;
    displayName?: string | null;
  }

  export interface IAccessTokenCacheEntry {
    cachedAt: string;
    clientId: string;
    credentialType: "AccessToken";
    environment: string;
    expiresOn: string; // Typically a UNIX timestamp as string
    extendedExpiresOn: string; // Also a UNIX timestamp as string
    homeAccountId: string;
    realm: string;
    secret: string;
    target: string;
    tokenType: string;
  }
  
  export interface IFeberAPIResponse {
    data: any;
    success: boolean;
    message?: string;
  }